import { Construction } from "lucide-react";
import { PageHeader, Card } from "../components/ui/card.js";
import { EmptyState } from "../components/ui/states.js";
import { useI18n } from "../i18n/index.js";

export function PlaceholderPage({
  title,
  slice,
  summary,
}: {
  title: string;
  slice: string;
  summary: string;
}) {
  const { t } = useI18n();
  return (
    <>
      <PageHeader
        title={title}
        description={t("common.placeholder.plannedFor", { slice })}
      />
      <Card>
        <EmptyState
          icon={Construction}
          title={t("common.placeholder.coming", { slice })}
          description={summary}
        />
      </Card>
    </>
  );
}
